import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import AddressAutocomplete from "./parts/address"
import {
  Tag,
  Icon,
  Input,
  Button,
  Spin,
  Row,
  Col,
  Divider,
  Tooltip,
  Select,
  Checkbox,
  message,
  Radio,
  Card,
  Typography,
  Modal,
  Form,
} from "antd";
import "./register.css";
import F from "../../Functions";
import axios from "axios";
import Cookies from "js-cookie";
import Sidebar from "./parts/sidebar-updated";
import AddOnModal from "./parts/add-on-modal";
import Header from "./parts/header";
import Footer from "./parts/footer";
import { isObject } from "lodash";
import { SET_EXT_USER_NOTIFICATIONS } from "../../utils/Api_enums";
// import ReCAPTCHA from 'react-google-recaptcha'
// import { reCAPTCHA_site_key } from "../../utils/Constants";

// const stripePromise = loadStripe(window.stripe);

const Option = Select.Option;
const { Text, Title } = Typography;

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const RadioGroup = Radio.Group;

class Register extends Component {
  state = {
    loading: false,
    user: {
      id: "",
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      visible_pass: false,
      visible_confirm_pass: false,
      confirm_password: "",
      agency_name: "",
      agency_address: "",
      street_address: "",
      billing_street_address: "",
      city: "",
      state: "",
      zipcode: "",
      billing_city: "",
      billing_state: "",
      billing_zipcode: "",
      country: "United States",
      phone_number: "",
      mobile_number: "",
      timezone: "",
      card_number: "",
      exp_month: "",
      exp_year: "",
      cvc: "",
      promo_code: "",
      billing_address: "",
      valid_promo_code: "",
      plan: "",
    },
    price: 1050,
    addOn: true,
    addOn_price: 200,
    show_addOn: false,
    agree: false,
    agree2: false,
    farmers_checkbox: null,
    formError: {},
    planes: [
      {
        id: "",
        addOnId: "",
        name: "Select Carrier...",
      },
      {
        id: "price_1Q8Tam2DVWmKiFC5Tfcq4L5S",
        addOnId: "price_1Q8Tf42DVWmKiFC59VrZZxGL",
        name: "Allstate",
      },
      {
        id: "price_1Q8Td62DVWmKiFC5f0Oxe2pM",
        addOnId: "price_1Q8ThR2DVWmKiFC50R2gYpTI",
        name: "Farmers",
      },
      {
        id: "price_1Q8Tci2DVWmKiFC5xXadEdfm",
        addOnId: "price_1Q8Th32DVWmKiFC5Xcxjag5n",
        name: "Country Financial",
      },
      {
        id: "price_1Q8Tbx2DVWmKiFC5DKgVZy0m",
        addOnId: "price_1Q8TfS2DVWmKiFC5q2OYB6J7",
        name: "Farm Bureau",
      },
      {
        id: "price_1Q8TeU2DVWmKiFC5q4V4x7tz",
        addOnId: "price_1Q8Thp2DVWmKiFC5j0hu4muT",
        name: "Independent Agent",
      },
    ],
    // captchaValue:null
  };

  componentDidMount = () => {
    window.document.body.classList.add("register");

    if (window.location.host.includes("localhost") || window.location.host.includes("beta") || window.location.host.includes("bfiledev")) {
      let planes = [
        {
          id: "",
          addOnId: "",
          name: "Select Carrier...",
        },
        {
          id: "price_1QD0yb2DVWmKiFC5pNSQAwQF",
          addOnId: "price_1QD0Cd2DVWmKiFC5t0ldklAM",
          name: "Allstate",
        },
        {
          id: "price_1QD0wd2DVWmKiFC5lFgYibbK",
          addOnId: "price_1QD0lz2DVWmKiFC5Luk9JdiG",
          name: "Farmers",
        },
        {
          id: "price_1QD0x72DVWmKiFC5FiDx9UbS",
          addOnId: "price_1QD0mP2DVWmKiFC5j3nPlWUy",
          name: "Country Financial",
        },
        {
          id: "price_1QD0xw2DVWmKiFC5hydQQ6Te",
          addOnId: "price_1QD0mf2DVWmKiFC5P7oJgKjR",
          name: "Farm Bureau",
        },
        {
          id: "price_1QD0w22DVWmKiFC5ztt1tRxK",
          addOnId: "price_1QD0lg2DVWmKiFC5c5LZPdJK",
          name: "Independent Agent",
        }
      ]
      this.setState({ planes })
    }
  };
  componentWillUnmount = () => {
    window.document.body.classList.remove("register");
  };
  updateField = (name, value) => {
    let { user } = this.state;
    if (name === "plan" && (value !== "price_1Q8Tbx2DVWmKiFC5DKgVZy0m" && value !== "price_1QD0xw2DVWmKiFC5hydQQ6Te"))
      this.setState({ farmers_checkbox: null })

    if (isObject(value))
      user = { ...user, ...value }
    else
      user[name] = value;
    this.setState({ user }, () => {
      if (name === "package") {
        this.promo_code_update();
      }
    });
  };
  timezone_offset = (timezone) => {
    const offsets = {
      "US/Samoa": "-11",
      "US/Hawaii": "-10",
      "US/Alaska": "-9",
      "US/Pacific": "-8",
      "US/Mountain": "-7",
      "US/Central": "-6",
      "US/Eastern": "-5",
    };
    if (typeof offsets[timezone] !== "undefined") {
      return offsets[timezone];
    } else {
      return null;
    }
  };
  generateArrayOfYears = () => {
    var min = new Date().getFullYear();
    var max = min + 15;
    var years = [];

    for (var i = min; i < max; i++) {
      years.push(i);
    }
    return years;
  };
  promo_code_update = () => {
    const { user, addOn } = this.state;
    let { price } = this.state;
    if (price != '850' || price != '1050') {
      if (addOn)
        price = 1050;
      else
        price = 850;
    }

    if (user.promo_code !== "") {
      message.destroy();
      this.setState({ loading: true });
      axios
        .post("/api/coupon_check", {
          coupon_code: user.promo_code,
        })
        .then((res) => {
          let error = false;
          if (typeof res.data.success !== "undefined" && !res.data.success) {
            error = true;
          }
          if (typeof res.data.valid !== "undefined" && !res.data.valid) {
            error = true;
          }
          if (!error && res.data.valid === true) {
            // if (res.data.valid !== true){
            //   message.error("Enter valid Promo Code");
            // }
            let discount = 0;
            user.valid_promo_code = user.promo_code;
            if (res.data.amount_off !== null) {
              discount = res.data.amount_off / 100;
            }
            if (res.data.percent_off !== null) {
              discount = (price * res.data.percent_off) / 100;
            }
            price = price - parseFloat(discount);
            this.setState({ user, price, loading: false });
          } else {
            this.setState({ price, loading: false });
            this.updateField("promo_code", "");
            message.error(F.translate(`Promo code not valid.`));
          }
        })
        .catch(() => {
          this.setState({ price, loading: false });
          this.updateField("promo_code", "");
          message.error(F.translate(`Please try again later.`));
        });
    } else {
      this.setState({ price });
    }
  };

  checkPromoCode = (value) => {
    if (value != "") {
      this.promo_code_update();
    }
    else {
      let { user, price, addOn } = this.state
      if (addOn)
        price = 1050;
      else
        price = 850;
      user.promo_code = ""
      user.valid_promo_code = ""
      this.setState({ price, user })
    }
  };

  validateField = (user) => {

    let { formError } = this.state;

    if (user.first_name === "")
      formError.first_nameValid = false;
    else
      formError.first_nameValid = true;

    if (user.last_name === "")
      formError.last_nameValid = false;
    else
      formError.last_nameValid = true;

    // if (user.street_address === "")
    //   formError.street_address = false;
    // else
    //   formError.street_address = true;

    // if (user.city === "")
    //   formError.city = false;
    // else
    //   formError.city = true;

    // if (user.state === "")
    //   formError.state = false;
    // else
    //   formError.state = true;

    // if (user.zipcode === "")
    //   formError.zipcode = false;
    // else
    //   formError.zipcode = true;

    if (user.email === "")
      formError.emailValid = false;
    else
      formError.emailValid = true;

    if (user.password === "")
      formError.passwordValid = false;
    else
      formError.passwordValid = true;

    if (user.confirm_password === "")
      formError.confirm_passwordValid = false;
    else
      formError.confirm_passwordValid = true;

    if (user.phone_number === "")
      formError.phone_number = false;
    else
      formError.phone_number = true;

    if (user.agency_name === "")
      formError.agency_nameValid = false;
    else
      formError.agency_nameValid = true;

    if (user.timezone === "")
      formError.timezoneValid = false;
    else
      formError.timezoneValid = true;

    if (user.plan === "")
      formError.planValid = false;
    else
      formError.planValid = true;

    if (user.card_number === "")
      formError.card_numberValid = false;
    else
      formError.card_numberValid = true;

    if (user.exp_month === "")
      formError.exp_monthValid = false;
    else
      formError.exp_monthValid = true;

    if (user.exp_year === "")
      formError.exp_yearValid = false;
    else
      formError.exp_yearValid = true;

    if (user.cvc === "")
      formError.cvcValid = false;
    else
      formError.cvcValid = true;

    // if (user.different_address) {
    //   if (user.billing_street_address === "")
    //     formError.billing_street_address = false;
    //   else
    //     formError.billing_street_address = true;

    //   if (user.billing_city === "")
    //     formError.billing_city = false;
    //   else
    //     formError.billing_city = true;

    //   if (user.billing_state === "")
    //     formError.billing_state = false;
    //   else
    //     formError.billing_state = true;

    //   if (user.billing_zipcode === "")
    //     formError.billing_zipcode = false;
    //   else
    //     formError.billing_zipcode = true;
    // }

    this.setState({ formError })
  };

  //parallel/async execution of api
  submit = () => {
    message.destroy();
    let { user, planes, addOn, captchaValue } = this.state;
    this.validateField(user);
    F.log("submit user 1 => ", user);
    if (
      user.agency_name === "" || user.email === "" || user.first_name === "" ||
      user.last_name === "" || user.password === "" || user.confirm_password === "" ||
      user.plan === "" || user.phone_number === "" || user.timezone === ""
    ) {
      message.error(F.translate(`Please fill all required fields.`));
    }
    else if (
      user.card_number === "" || user.exp_month === "" ||
      user.exp_year === "" || user.cvc === ""
    ) {
      message.error(F.translate(`Card info missing.`));
    }
    // else if (user.different_address &&
    //   (user.billing_street_address === "" || user.billing_city === "" || user.billing_state === "" || user.billing_zipcode === "")
    // ) {
    //   message.error(F.translate(`Please fill all required fields.`));
    // }
    else if (!F.validateEmail(user.email)) {
      message.error(
        F.translate(`Please enter a valid email.`)
      );
    }
    else if (user.password !== user.confirm_password) {
      message.error(
        F.translate(`Confirmation password does not match the password.`)
      );
    }
    else if (user.password && !F.password_verify(user).name_complexity_equirements()) {
      message.error(F.translate("Password must not include the user's first or last name."))
    }
    else if (user.password && !F.password_verify(user).password_length()) {
      message.error(F.translate(`Password should contain atleast 9 digits and not more than 20 digits.`));
    }
    else if (user.password && !F.password_verify(user).complexity_equirements()) {
      message.error(F.translate('Password should contain Uppercase letters, Lowercase letters, Numbers and Special characters.'))
    }
    else if (/^\d*$/.test(user.phone_number) && user.phone_number.length <= 10)
      message.error(
        F.translate(`Please enter a valid phone number.`)
      );
    else if (user.agency_address === "") {
      let agency_address = [
        user.street_address,
        user.street_address2,
        user.city,
        user.state,
        user.zipcode,
      ]
        .filter((value) => value)
        .join(", ") || "NA"
      agency_address += ", US"
      user = { ...user, agency_address }
      this.setState({ user }, () => {
        this.submit();
      });
    }
    else if (user.mobile_number != null &&
      user.mobile_number.trim().length > 0 &&
      !F.validatePhoneRegix(user.mobile_number.trim()))
      message.error(
        F.translate(`Please enter a valid mobile number.`)
      );
    else {
      if (this.state.farmers_checkbox === "Yes") {
        window.open(
          "https://na3.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=c8839f43-1084-4804-8d07-c793db0fd903&env=na3&acct=bf37d7c4-5862-4a64-8220-5d6037b83a54&v=2",
          "_blank",
          "noopener noreferrer"
        );
      }
      this.setState({ loading: true });
      if (
        user.stripe_token === "" ||
        (user.stripe_token !== "" &&
          user.stripe_card_number !== user.card_number)
      ) {
        window.Stripe.setPublishableKey(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
        
        window.Stripe.createToken(
          {
            number: user.card_number,
            cvc: user.cvc,
            exp_month: user.exp_month,
            exp_year: user.exp_year,
          },
          (status, response) => {
            F.log("submit user 2 => ", user);
            const stripe_token = response.id;
            this.setState({ loading: false });
            if (response.error) {
              F.log("submit user 3 error => ", user);
              message.error(response.error.message);
            } else {
              user.stripe_token = stripe_token;
              user.stripe_card_number = user.card_number;
              this.setState({ user }, () => {
                this.submit();
              });
            }
          }
        );
      } else {
        const planObj = planes.find(e => e && e.id === user.plan) || {}
        const plan = addOn ? planObj.addOnId : planObj.id

        let payload = {
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          user_type: "EA",
          phone: user.phone_number,
          mobile_number: user.mobile_number,
          timezone: user.timezone,
          timezone_offset: this.timezone_offset(user.timezone),
          // subscription: user.plan,
          subscription: plan,
        };
        if (user.valid_promo_code !== "") {
          payload.coupon_code = user.valid_promo_code;
        }

        let ajax = null;
        if (user.id !== "") {
          ajax = axios.put("/api/users/" + user.id, payload);
          axios.post("/api/update_password", {
            password: user.password,
          });
        } else {
          payload.password = user.password;
          ajax = axios.post("/api/register", payload);
        }
        ajax
          .then((res) => {
            const registred_user = res.data;
            const userId = registred_user.id;
            user.id = registred_user.id;
            this.setState({ user });

            axios.get("/api/user").then((res) => {
              const loggedin = res.data;
              Cookies.set("is_logged_in", "true", {
                secure: true,           //  HTTPS only
                sameSite: 'Lax',        // Add this — fixes the scan finding
                path: '/',              // explicit path
              });
              Cookies.set(
                "user_info",
                JSON.stringify({
                  first_name: loggedin.first_name,
                  last_name: loggedin.last_name,
                  email: loggedin.email,
                  id: loggedin.id,
                  user_type: loggedin.user_type,
                  jobs: loggedin.jobs,
                  default_date: loggedin.default_date,
                  last_login: loggedin.last_login,
                  language: loggedin.language,
                  agency_id: loggedin.user_agency_assoc ? loggedin.user_agency_assoc[0] ? loggedin.user_agency_assoc[0].agency_id : null : null
                }), {
                secure: true,           //  HTTPS only
                sameSite: 'Lax',        // Add this — fixes the scan finding
                path: '/',              // explicit path
              }
              );
            });

            let payload = {
              type: "CREDIT",
              stripe_token: user.stripe_token,
              // subscription: user.plan,
              subscription: plan,
              billing_address: user.different_address ? {
                "line1": user.billing_street_address || "",
                "line2": user.billing_street_address2 || "",
                "city": user.billing_city || "",
                "state": user.billing_state || "",
                "postal_code": user.billing_zipcode || "",
                "country": "US"
              } : {
                "line1": user.street_address || "",
                "line2": user.street_address2 || "",
                "city": user.city || "",
                "state": user.state || "",
                "postal_code": user.zipcode || "",
                "country": "US"
              }
            };
            if (user.valid_promo_code !== "") {
              payload.coupon_code = user.valid_promo_code;
            }
            axios
              .post("/api/charge", payload)
              .then((res) => {
                if (res.data.success) {
                  let agency_payload = {
                    name: user.agency_name,
                    primary_ea_id: registred_user.id,
                    address: user.agency_address,
                    state: user.state,
                    billing_address: user.different_address ? user.billing_address : user.agency_address,
                    active: 1,
                    // vonboard: 1,
                  };

                  const planObj = planes.find((item) => item.id === user.plan);
                  const customer = planObj.name
                    .toLowerCase()
                    .replace(/ /g, "-");
                  const identifier = "bfile-user-" + registred_user.id;

                  axios.post("/api/agencies", agency_payload)
                    .then((res) => {
                      return axios.post("/api/user_agency_assoc", {
                        agency_id: res.data.id,
                        user_id: registred_user.id,
                      });
                    })
                    .then((res) => {
                      if (userId) {
                        axios.post(SET_EXT_USER_NOTIFICATIONS, {
                          user_id: userId,
                          status: true
                        }).catch(() => { });
                      }
                    })
                    .then((res) => {
                      return axios.post("/api/tango/create_account", {
                        customer: customer,
                        identifier: identifier,
                        email: user.email,
                      });
                    })
                    .then((res) => {
                      const carrier = planObj.name
                      let minimum_liability_limits_ext = {}
                      if (carrier === "Farm Bureau") {
                        minimum_liability_limits_ext = {
                          "Home": "100,000",
                          "Auto": "100/300",
                          "Suggested Minimum Life Insurance": "3x"
                        }
                      } else {
                        minimum_liability_limits_ext = {
                          "Home": "$100,000",
                          "Auto": "$25,000/$50,000",
                          "Suggested Minimum Life Insurance": "3x"
                        }
                      }

                      axios
                        .put("/api/users/" + registred_user.id, {
                          tango_identifier_v2: identifier,
                          tango_customer: customer,
                          street_one: user.street_address,
                          street_two: user.street_address2,
                          city: user.city,
                          state: user.state,
                          zipcode: user.zipcode,
                          carrier: carrier,
                          language: "en",
                          address: user.agency_address,
                          minimum_liability_limits_ext: JSON.stringify(minimum_liability_limits_ext),
                        })
                        .then(() => {
                          axios.post("/api/set_user_for_review_scheduler_stats_notification",
                            {
                              "user_id": registred_user.id,
                              "status": true
                            }
                          )
                          // axios.post("/api/set_user_for_notification_of_bad_phone_number",
                          //   {
                          //     "user_id": registred_user.id,
                          //     "status": true
                          //   }
                          // )
                          this.setState({ loading: false });
                          this.props.history.push("/dashboard");
                        })
                        .catch(() => {
                          this.setState({ loading: false });
                          message.error(F.translate(`Please try again later.`));
                        });
                    })
                    .catch(() => {
                      this.setState({ loading: false });
                      message.error(F.translate(`Please try again later.`));
                    });
                } else {
                  this.setState({ loading: false });
                  if (typeof res.data.message !== "undefined") {
                    message.error(res.data.message);
                  } else {
                    message.error(F.translate(`Please try again later.`));
                  }
                }
              })
              .catch((res) => {
                this.setState({ loading: false });
                if (res.data && res.data.message && typeof res.data.message !== "undefined") {
                  message.error(res.data.message);
                } else {
                  message.error(F.translate(`Please try again later.`));
                }
              });
          })
          .catch((err) => {
            this.setState({ loading: false });
            message.error(
              F.translate(`Email already exists, please try with another.`)
            );
            // if (
            //   typeof res.data !== "undefined" &&
            //   typeof res.data.message !== "undefined"
            // ) {
            //   if (res.data.message === "IntegrityError") {
            //     message.error(
            //       F.translate(`Email already exists in the system.`)
            //     );
            //   } else {
            //     message.error(res.data.message);
            //   }
            // } else {
            // message.error(F.translate(`Please try again later.`));
            // }
          });
      }
    }
  };

  toggleVisibility = (type) => {
    if (type === 'password')
      this.setState({ visible_pass: !this.state.visible_pass }) // NOSONAR
    else
      this.setState({ visible_confirm_pass: !this.state.visible_confirm_pass }) // NOSONAR
  };

  paymentCalculation = (checked) => {
    let { price, addOn_price, user, addOn, planes } = this.state

    if (checked) {
      addOn = true
      price += price === 850 ? addOn_price : 0
    } else {
      addOn = false
      price -= price === 1050 ? addOn_price : 0
    }

    if (user.promo_code != "") {
      user.promo_code = "";
      user.valid_promo_code = "";
      if (checked)
        price = 1050;
      else
        price = 850;
    }

    this.setState({ price, addOn, user })
  }

  handleExpDateChange = (e) => {
    let value = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
    // Format the value as mm/yy

    if (value.length >= 2) {
      const month = parseInt(value.slice(0, 2), 10);
      if (month < 1 || month > 12) {
        value = '12' + value.slice(2); // If invalid, default to "12"
      }
      value = value.slice(0, 2) + '/' + value.slice(2, 4);
    }
    this.updateField("exp_date", value)
  };

  validateExpiryDate = (e) => {
    const inputValue = e.target.value
    const month = inputValue.split("/")[0]
    const year = inputValue.split("/")[1]

    this.updateField("exp_year", "")
    this.updateField("exp_month", "")
    if (year < new Date().getFullYear().toString().slice(-2))
      return message.error("It seems your card is expired. Please try with another")
    else if (year === new Date().getFullYear().toString().slice(-2) && month < new Date().getMonth() + 1)
      return message.error("It seems your card is expired. Please try with another")
    else {
      this.updateField("exp_year", year)
      this.updateField("exp_month", month)
    }
  }

  handlebillingAddress = (e) => {
    const checked = e.target.checked
    let billing_address = {}
    if (!checked) {
      billing_address = {
        "different_address": checked,
        "billing_address": "",
        "billing_street_address": "",
        "billing_street_address2": "",
        "billing_city": "",
        "billing_state": "",
        "billing_zipcode": "",
      }
    } else {
      billing_address = {
        "different_address": checked,
      }
    }
    this.updateField("billing_address", billing_address)
  }

  planFeatures = (item, i) => {
    return (
      <Col span={11} key={i}>
        <span><b style={{ color: "#1890ff", fontFamily: "fontawesome" }}>✓ </b><Text>{item}</Text></span>
      </Col>
    );
  };

  render() {
    const { loading, user, price, agree, agree2, planes, addOn } = this.state;
    const updateField = this.updateField;

    const addOns = ["Prospect", "Requotes", "Win-Back", "Event Follow-Up Calls"]

    return (
      <div className="register-form" style={{ border: "none" }}>
        <Row className="header">
          <Header />
        </Row>
        <Row type="flex" style={{ padding: 20 }}>
          <Sidebar />
          <Col md={16} span={24} style={{ paddingLeft: 20 }}>
            <Spin indicator={antIcon} spinning={loading}>
              {/* <h1>Register</h1>
              <p>{`Sell more life, retirement & P&C items with the world's best insurance opportunity platform.`}</p>
              <Divider /> */}
              <h1 className="secTitle">
                <strong><span className="secNum">1.</span> Tell us about your agency</strong>
              </h1>
              <Row gutter={16}>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>First Name:
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      value={user.first_name}
                      onChange={(e) => {
                        const val = (e.target.value.replace(/^\s+/, ''));
                        updateField("first_name", val)
                      }}
                      className={this.state.formError.first_nameValid == false ? "invalid" : ""}
                      name="first_name"
                      maxLength={30}
                    />
                  </div>
                </Col>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>Last Name:
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      value={user.last_name}
                      onChange={(e) => {
                        const val = (e.target.value.replace(/^\s+/, ''));
                        updateField("last_name", val)
                      }}
                      maxLength={30}
                      className={this.state.formError.last_nameValid == false ? "invalid" : ""}
                      name="last_name"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={24} span={24}>
                  <AddressAutocomplete updateField={updateField} user={user} formError={this.state.formError} type="Agency Address" />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>Email:
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      value={user.email}
                      maxLength={254}
                      onChange={(e) => {
                        const val = (e.target.value.replace(/^\s+/, '')); //Remove space from the start
                        updateField("email", val)
                      }}
                      className={this.state.formError.emailValid == false ? "invalid" : ""}
                    />
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>
                      Password:
                      <span className="asteriskIcon">*</span>
                      <div className="right">
                        <Tooltip
                          placement="bottom"
                          title={`Password must be 9-20 characters, include at least 1 Uppercase character, 1 Lowercase character, 1 Numeric digit and a Special character.`}
                          getPopupContainer={() => document.body}
                        >
                          <Icon
                            type="info"
                            style={{ background: "#4fb5f5", color: "white", borderRadius: "1rem" }}
                          />
                        </Tooltip>
                      </div>
                    </label>
                    <Input
                      type={this.state.visible_pass ? 'text' : 'password'}
                      value={user.password}
                      onChange={(e) => updateField("password", e.target.value)}
                      className={this.state.formError.passwordValid == false ? "invalid" : ""}
                      suffix={
                        <Icon
                          type={this.state.visible_pass ? 'eye-invisible' : 'eye'}
                          onClick={() => this.toggleVisibility('password')}
                          style={{ cursor: 'pointer' }}
                        />
                      }
                    />
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>Confirm Password:
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      type={this.state.visible_confirm_pass ? 'text' : 'password'}
                      value={user.confirm_password}
                      className={this.state.formError.confirm_passwordValid == false ? "invalid" : ""}
                      onChange={(e) =>
                        updateField("confirm_password", e.target.value)
                      }
                      suffix={
                        <Icon
                          type={this.state.visible_confirm_pass ? 'eye-invisible' : 'eye'}
                          onClick={() => this.toggleVisibility('confirm_password')}
                          style={{ cursor: 'pointer' }}
                        />
                      }
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>Phone Number:
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      className={this.state.formError.phone_number == false ? "invalid" : ""}
                      value={F.phone_format(user.phone_number)}
                      onChange={(e) => {
                        const input = e.target.value;
                        const inputValue = input.replace(/\D/g, ''); // Remove non-digit characters
                        if (/^\d*$/.test(inputValue) && inputValue.length <= 14) {
                          const updateNumber = F.phone_format(inputValue);
                          updateField("phone_number", updateNumber)
                        }
                      }}
                    />
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>Mobile Number:</label>
                    <Input
                      value={user.mobile_number}
                      onChange={(e) => {
                        const input = e.target.value;
                        const inputValue = input.replace(/\D/g, ''); // Remove non-digit characters
                        if (/^\d*$/.test(inputValue) && inputValue.length <= 14) {
                          const updateNumber = F.phone_format(inputValue);
                          updateField("mobile_number", updateNumber)
                        }
                      }}
                    />
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>Timezone:
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Select
                      defaultValue={user.timezone}
                      style={{ width: "100%" }}
                      onChange={(value) => this.updateField("timezone", value)}
                      className={this.state.formError.timezoneValid == false ? "invalid" : ""}
                    >
                      <Option value={""}>{"Select Timezone..."}</Option>
                      <Option value="US/Eastern">
                        Eastern (-05:00)
                      </Option>
                      <Option value="US/Central">
                        Central (-06:00)
                      </Option>
                      <Option value="US/Mountain">
                        Mountain (-07:00)
                      </Option>
                      <Option value="US/Pacific">
                        Pacific (-08:00)
                      </Option>
                      <Option value="US/Alaska">
                        Alaska (-09:00)
                      </Option>
                      <Option value="US/Hawaii">
                        Hawaii-Aleutian (-10:00)
                      </Option>
                      <Option value="US/Samoa">
                        Samoa (-11:00)
                      </Option>
                    </Select>
                  </div>
                </Col>
              </Row>
              <h1 className="secTitle">
                <strong><span className="secNum">2.</span> Choose Your Carrier</strong>
              </h1>
              <div className="inputField">
                <label>Carrier:
                  <span className="asteriskIcon">*</span>
                </label>
                <Select
                  defaultValue={user.plan}
                  style={{ width: "100%" }}
                  onChange={(value) => {
                    this.updateField("plan", value)
                    value === "price_1Q8Tci2DVWmKiFC5xXadEdfm" || value === "price_1QD0x72DVWmKiFC5FiDx9UbS" ? this.paymentCalculation(true) : this.paymentCalculation(addOn)
                  }}
                  className={this.state.formError.planValid == false ? "invalid" : ""}
                >
                  {planes.map((item, i) => {
                    return (
                      <Option key={`${i}`} value={item.id}>
                        {item.name}
                      </Option>
                    );
                  })}
                </Select>
              </div>
              {/* {user.plan === "price_1IEDol2DVWmKiFC53MWJWvIi" ? ( */}
              {user.plan === "price_1Q8Tbx2DVWmKiFC5DKgVZy0m" || user.plan === "price_1QD0xw2DVWmKiFC5hydQQ6Te" ? (
                <div className="inputField">
                  <Row gutter={16}>
                    <Col md={12} span={24}>
                      Do you want to use Payroll Deduct?
                    </Col>
                    <Col md={12} span={24}>
                      <RadioGroup
                        value={this.state.farmers_checkbox}
                        onChange={(e) => {
                          this.setState({ farmers_checkbox: e.target.value });
                        }}
                        options={[
                          { label: "Yes", value: "Yes" },
                          { label: "No", value: "No" },
                        ]}
                      />
                    </Col>
                  </Row>
                </div>
              ) : null}
              <h1 className="secTitle">
                <strong>3. Looking for Additional Sales?</strong>
              </h1>
              <Card className="sub-card">
                <Row style={{ display: "flex" }}>
                  <span className="title-tag">B File +</span>
                  <Checkbox
                    defaultChecked
                    disabled={user.plan === "price_1Q8Tci2DVWmKiFC5xXadEdfm" || user.plan === "price_1QD0x72DVWmKiFC5FiDx9UbS"}
                    checked={addOn}
                    onChange={(e) => this.paymentCalculation(e.target.checked)}
                    style={{ position: "absolute", right: 20, transform: "scale(1.5)", backgroundColor: "#43ade2" }}>
                  </Checkbox>
                </Row>
                <Row style={{ padding: "20px 30px" }}>
                  <Col>
                    <span>Add our Lead Appointment Enhancement, which provides the following add-on-call services:</span>
                  </Col>
                  <Row gutter={[0, 16]} style={{ marginTop: 10 }}>
                    {addOns.map((item, i) => this.planFeatures(item, i))}
                  </Row>
                  <label level={2} style={{ fontWeight: 700, fontSize: 24, color: 'black' }}>
                    +$200<span style={{ fontSize: '16px', color: '#888' }}>/mo</span>
                  </label>
                </Row>
              </Card>
              <h1 className="secTitle">
                <strong><span className="secNum">4.</span> Enter payment details</strong>
              </h1>
              {/* <div>
                <PaymentElement />
              </div> */}
              <Row gutter={16}>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>Card Number:
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      value={user.card_number}
                      placeholder="000 000 000 0000"
                      type="digit"
                      onChange={(e) => {
                        const inputValue = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
                        updateField("card_number", inputValue)
                      }}
                      className={this.state.formError.card_numberValid == false ? "invalid" : ""}
                    />
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>Exp Date:
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      placeholder="MM/YY"
                      value={(user.exp_date)}
                      type="digit"
                      onChange={(e) => this.handleExpDateChange(e)}
                      onBlur={(e) => this.validateExpiryDate(e)}
                      className={this.state.formError.exp_monthValid === false || this.state.formError.exp_yearValid === false ? "invalid" : ""}
                      maxLength={5}
                    />
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>CVV:
                      <span className="asteriskIcon">*</span>
                      <div className="right">
                        <Tooltip
                          placement="bottom"
                          title={`${user.card_number.startsWith('3') ? "Please enter your 4 digit cvv code." : "Please enter your 3 digit cvv code."}`}
                          getPopupContainer={() => document.body}
                        >
                          <Icon
                            type="info"
                            style={{ background: "#4fb5f5", color: "white", borderRadius: "1rem" }}
                          />
                          {/* <Icon
                            type="exclamation-circle-o"
                            style={{ color: "#1890ff" }}
                          /> */}
                        </Tooltip>
                      </div>
                    </label>
                    <Input
                      value={user.cvc}
                      placeholder={user.card_number.startsWith('3') ? "****" : "***"}
                      maxLength={user.card_number.startsWith('3') ? 4 : 3}
                      onChange={(e) => {
                        const inputValue = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
                        updateField("cvc", inputValue)
                      }}
                      // updateField("cvc", e.target.value)}
                      className={this.state.formError.cvcValid == false ? "invalid" : ""}
                    />
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>Promo Code:</label>
                    <Input
                      placeholder="Insert promo code"
                      value={user.promo_code}
                      onChange={(e) =>
                        updateField("promo_code", e.target.value)
                      }
                      onBlur={(e) => this.checkPromoCode(e.target.value)}
                    />
                  </div>
                </Col>
                {/* <Col md={12} span={24}>
                  <div className="inputField">
                    <label>Billing Address (Optional):</label>
                    <Input
                      placeholder="If different than agency address"
                      value={user.billing_address}
                      onChange={(e) =>
                        updateField("billing_address", e.target.value)
                      }
                    />
                  </div>
                </Col> */}
                <Col md={16} span={24}>
                  <Checkbox onChange={
                    (e) => this.handlebillingAddress(e)}>Is your billing address different than your agency address?</Checkbox>
                </Col>
              </Row>
              {user.different_address &&
                (<Col md={24} span={24}>
                  <AddressAutocomplete updateField={updateField} user={user} formError={this.state.formError} type="Billing Address" />
                </Col>
                )}
              <div className="price">
                <span>Total:</span>
                <br />
                <span style={{ fontWeight: 700, fontSize: 24, color: 'black' }}>{F.dollar_format(price, 2)}</span>
              </div>

              <div className="">
                <p>
                  <Checkbox
                    checked={agree}
                    onChange={(e) => this.setState({ agree: e.target.checked })}
                  >
                    By creating an account, you agree to our{" "}
                    <a href="/app/#/privacy-policy/" target="_blank">
                      <u>Privacy Policy</u>
                    </a>
                    ,{" "}
                    <a href="/app/#/terms-of-service/" target="_blank">
                      <u>Terms of Use & License Agreement</u>.
                    </a>
                  </Checkbox>
                </p>
                <p>
                  <Checkbox
                    checked={agree2}
                    onChange={(e) => this.setState({ agree2: e.target.checked })}
                  >
                    {/* I understand I am signing up and committing to a {user.plan === 'price_1Q8Tci2DVWmKiFC5xXadEdfm' || user.plan === "price_1QD0x72DVWmKiFC5FiDx9UbS" ? "6" : "12"} month */}
                    I understand I am signing up and committing to a 12 month
                    subscription.
                  </Checkbox>
                </p>
                {/* <p style={{borderBottom: "1px solid #E8E8E8"}}></p> */}
              </div>
              {/* <ReCAPTCHA sitekey={reCAPTCHA_site_key} onChange={(e)=>this.setState({captchaValue:e})} /> */}
              <div style={{
                transform: "translate(20%)"
              }}>
                {/* {user.plan === "price_1IEDol2DVWmKiFC53MWJWvIi" && */}
                {(user.plan === "price_1Q8Tbx2DVWmKiFC5DKgVZy0m" || user.plan === "price_1QD0xw2DVWmKiFC5hydQQ6Te") &&
                  this.state.farmers_checkbox === null ? (
                  <Button type="primary" disabled={true}
                    className="demo-button"
                  >
                    REGISTER
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    className="demo-button"
                    onClick={() => {
                      this.state.addOn ? this.submit() : this.setState({ show_addOn: true })
                    }}
                    disabled={agree && agree2 ? false : true}
                  >
                    REGISTER
                  </Button>
                )}
              </div>

              {this.state.show_addOn &&
                (
                  <AddOnModal
                    submit={this.submit}
                    showModal={this.state.show_addOn}
                    hideModal={() => this.setState({ show_addOn: false })}
                  />)
              }
            </Spin>
          </Col>
        </Row>
        <Row className="register-footer">
          <Footer />
        </Row>
      </div >
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/scenes/Register/register-ea_updated.js